export const READINESS_STATUS = {
  READY: 'ready',
}

export const ASSET_STATUS = {
  FUNCTIONAL:     'functional',
  MAINTENANCE:    'maintenance',
  OUT_OF_SERVICE: 'outOfService',
}

export const getAssetStatusColor = status => {
  if (status === ASSET_STATUS.FUNCTIONAL) return 'green'
  if (status === ASSET_STATUS.MAINTENANCE) return 'yellow'
  if (status === ASSET_STATUS.OUT_OF_SERVICE) return 'red'
  return 'grey'
}

export const ROADBLOCK_STATUS = {
  OPEN:     'open',
  RESOLVED: 'resolved',
}

export const MOVE_STATUS = {
  PENDING:   'pending',
  COMPLETE:  'complete',
  COMPLETED: 'completed',
}

export const MEMBER_STATUS = {
  ACTIVE:   'active',
  SICK:     'sick',
  TRAINING: 'training',
}
